import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "Welcome": "Welcome to the website",
      "About Us": "About Us",
      "Careers": "Careers",
      "Contact US": "Contact US",
      "Stores": "Stores",
      "follow Us On": "follow Us On",
      "Category": "Category",
      "Offers": "Offers",
      "New arrival": "New arriva",
      "SHOW MORE": "SHOW MORE",
      "HIDE": "HIDE",
      "YOUR ONE-STEP SHOP TO": "YOUR ONE-STEP SHOP TO",
      "ALL WHAT YOU NEED": "ALL WHAT YOU NEED",
      "EMPLOYERS": "EMPLOYERS",
      "PRODUCTS": "PRODUCTS",
      "LANGUAGES": "LANGUAGES",
      "WAREHOUSES": "WAREHOUSES",
      "brands": "Brands",
      "categories": "Categories",
      "prices": "Prices",
      "discounts": "Discounts",
      "colors": "Colors",
      "sizes": "Sizes",
      "products": "products",
      "Sort by": "Sort by",
      "Store categories": "Store categories",
      "+Follow": "+Follow",
      "products search...": "products search...",
      "Track Orders": "Track Orders",
      "Order Number": "Order Number",
      "Order": "Order",
      "Date": "Date",
      "Status": "Status",
      "Total": "Total",
      "For": "For",
      "Items": "Items",
      "Actions": "Actions",
      "View": "View",
      "Total Quantity": "Total Quantity",
      "Total Price": "Total Price",
      "Promos & Vouchers": "Promos & Vouchers",
      "Discount Voucher": "Discount Voucher",
      "Shipping Fee": "Shipping Fee",
      "Order Received": "Order Received",
      "In Progress": "In Progress",
      "On The Way": "On The Way",
      "Delivered": "Delivered",
      "Your request has been received successfully.": "Your request has been received successfully.",
      "Your request is in progress.": "Your request is in progress.",
      "The order has been shipped. It should arrive within 24 hours.": "The order has been shipped. It should arrive within 24 hours.",
      "Your order has been successfully delivered.": "Your order has been successfully delivered.",

      "Cancel Returns & Exchanges": "Cancel Returns & Exchanges",
      "On the way to get the order": "On the way to get the order",
      "Received & inspected": "Received & inspected",
      "Your return request has been received.": "Your return request has been received.",
      "The representative is on his way to receive the product.": "The representative is on his way to receive the product.",
      "Returns": "Returns",
      "Exchanges": "Exchanges",

      "Returns & Exchanges": "Returns & Exchanges",
      "Request Returns & Exchanges": "Request Returns & Exchanges",
      "You Have No Returns History": "You Have No Returns History",
      "You Have No Exchanges History": "You Have No Exchanges History",
      
      "Personal Information": "Personal Information",
      "First Name": "First Name",
      "Last Name": "Last Name",
      "Date Of Birth": "Date Of Birth",
      "Gender": "Gender",
      "Female": "Female",
      "Male": "Male",
      "Choose Language": "Choose Language",
      "Ar": "Arabic",
      "En": "English",
      "Number": "Number",
      "Nationality": "Nationality",
      "Address": "Address",
      "Image": "Image",
      "Click Here to upload Photo": "Click Here to upload Photo",
      "Submit": "Submit",
      "Security": "Security",
      "Email": "Email",
      "Password": "Password",
      "Change Password": "Change Password",
      "Log Out": "Log Out",
      "Delete Account": "Delete Account",
      "Payment Methods": "Payment Methods",
      "Add New Card": "Add New Card",
      "Your Payment Method is empty": "Your Payment Method is empty",

      "My Points": "My Points",
      "YOUR POINTS": "YOUR POINTS",
      "Earned this month": "Earned this month",
      "Ends this month": "Ends this month",
      "points": "points",
      "Available balance": "Available balance",
      "Buy more and earn points": "Buy more and earn points",
      "One point is equal to one dinar": "One point is equal to one dinar",
      "Points expire after one year": "Points expire after one year",
      "My Orders": "My Orders",

      "Wishlist": "Wishlist",
      "Off": "Off",
      "Your Wishlist is empty": "Your Wishlist is empty",
      'Points': 'Points',

      "myAccount": "My Account",
      "myOrders": "My Orders",
      "trackOrders": "Track Orders",
      "returns": "Returns ",
      "wishlistInfluencer": "Wishlist & Influencer",
      "myPoints": "My Points",


      "Welcome to the new Experience": "Welcome to the new Experience",
      "Create your password": "Create your password",
      "Confirm Password": "Confirm Password",
      "CONTINUE": "CONTINUE",
      "Password changed successfully": "Password changed successfully",
      "Please log in now.": "Please log in now.",
      "VERIFY YOUR EMAIL ADDRESS": "VERIFY YOUR EMAIL ADDRESS",
      "Verify your email using the OTP sent to your email address": "Verify your email using the OTP sent to your email address",
      "Resend OTP": "Resend OTP",
      "OTP": "OTP",
      "Please enter email": "Please enter email",

      "Create your account": "Create your account",
      "Log in": "Log in",
      "Sign up": "Sign up",
      "Forgot Password": "Forgot Password",
      "OR LOGIN WITH SOCIAL": "OR LOGIN WITH SOCIAL",
      "Login Instagram": "Login Instagram",
      "Login Apple": "Login Apple",
      "welcome": "Welcome to the new Experience",
      "createAccount": "Create your account",
      "login": "Log in",
      "signup": "Sign up",
      "enterEmail": "Please enter email",
      "password": "Password",
      "firstName": "First Name",
      "lastName": "Last Name",
      "eightCharsMin": "8 Characters Minimum",
      "oneLetter": "At least one letter",
      "oneNumber": "At least one number",
      "orLoginWithSocial": "OR LOGIN WITH SOCIAL",
      "loginInstagram": "Login Instagram",
      "loginApple": "Login Apple",
      "continue": "CONTINUE",
      "loginWithGoogle": "Login in with Google",
      "loginWithFacebook": "Login in with Facebook",
      "fillFieldsWithValidInfo": "Please fill in all fields with valid information.",
      "passwordRequirements": "Password must contain uppercase, lowercase letters, and numbers.",
      "registrationFailed": "Registration failed. Please try again.",
      "generalError": "An error occurred. Please try again later.",
      "loginSuccessful": "Login successful!",
      "favorites": "Favorites",
      "new_arrival": "New Arrival",
      "Filter": "Filter",
      "E-mail": "E-mail",
      "Sign Up": "Sign Up",
      "SELL ON ASHTIRI": "Sell on Ashtiri",
      "Recommend for You": "Recommend for You",
      "Best of": "Best of",
      "Whats hot in category": "What's hot in category",
      "Store": "Stores",
      "Influencer": "Influencers",
      "product_details": "Product Details",
      "material": "Material",
      "material_composition": "Material Composition",
      "care_instructions": "Care Instructions",
      "comfort": "Nature's Comfort",
      "occasion": "Occasion",
      "model": "Model",
      "shipping": "Shipping",
      "reviews": "Reviews",
      "average_rating": "Average Rating",
      "out_of": "Out of",
      "stars": "stars",
      "add_to_basket": "Add to Basket",
      "buy_now": "Buy Now",
      "write_review": "Write a Review",
      "what_do_you_think": "What do you think about this product?",
      "no_comments_yet": "No comments yet.",
      "write_comment": "Write your comment here...",
      "addToBasket": "Add to Basket",
      "buyNow": "Buy Now",
      "color": "Color",
      "size": "Size",
      "quantity": "Quantity",
      "productDetails": "Product Details",
      "materialComposition": "Material Composition",
      "warrantyAndCare": "Warranty & Care",
      "careInstructions": "Care Instructions",
      "generalSpecifications": "General Specifications",
      "naturesComfort": "Nature's Comfort",
      "averageRating": "Average Rating",
      "outOf": "Out of 5 stars",
      "writeReview": "Write a Review",
      "commentPlaceholder": "Write your comment here...",
      "productComments": "Product Comments",
      "noComments": "No comments yet.",
      "submit": "Submit",
      "selectColor": "Please select a color",
      "selectSize": "Please select a size",
      "selectQuantity": "Please select a quantity",
      "trending": "Trending",
      "total_quantity": "Total quantity",
      "total_price": "Total Price",
      "discount_voucher": "Discount Voucher",
      "shipping_fee": "Shipping Fee",
      "checkout_now": "Checkout Now",
      "payment_methods": "Ways you can pay:",
      "new_customers": "For New Customers",
      "off": "Off",
      "please_enter_order_code": "Please enter the order code",

      "Ashtiri Intro": "Ashtiri is a multi-store online marketplace in Kuwait and the Gulf, offering convenient and reliable solutions to meet all your daily needs, whether you are a woman, child, or man. 🛍️🌟",
      "Founded in 2024": "Founded in 2024, Ashtiri aims to connect suppliers and consumers, providing top-quality products from renowned luxury brands in fashion and beauty.",
      "Our Mission": "Our Mission",
      "Our Goal": "We aim to be the most customer-focused company in the Middle East, providing an exceptional and convenient shopping experience. 🎯",
      "Our Values": "Our Values",
      "Customer First": "Customer First",
      "Passion for Excellence": "Passion for Excellence",
      "Operational Excellence": "Operational Excellence",
      "Long Term Thinking": "Long-Term Thinking",
      "Customer Feedback": "Listening to Customer Feedback",
      "Our Products": "Our Products",
      "Products Range": "Choose from a wide range of products, including clothing, sports, shoes, bags, perfumes, makeup, sunglasses, watches, and much more. 🛒",
      "Contact Us": "Contact Us",
      "Contact Help Text": "Can't find the answer you're looking for? We're here to help:",
      "Phone": "Phone",
      "Mobile & WhatsApp": "Mobile & WhatsApp",
      faq: {
        question1: "What payment methods are available?",
        answer1: "We accept Knet, Visa, MasterCard, and cash on delivery.",
        question2: "How long does delivery take?",
        answer2: "It depends on the location, typically between 3 to 7 working hours within Kuwait.",
        question3: "Can I track my order?",
        answer3: "Yes, you will receive a tracking number, and you can check your order status on our website.",
        question4: "What are the return and exchange policies?",
        answer4: "We offer a flexible return policy within 14 days of receiving the order.",
        question5: "Do you offer international shipping?",
        answer5: "Yes, we provide shipping to most countries.",
        question6: "Can I change or cancel my order after placing it?",
        answer6: "You can change or cancel your order within two hours of placing it.",
        question7: "Do you offer discounts or special offers?",
        answer7: "Yes, we regularly offer discounts and special promotions.",
        question8: "How can I contact customer service?",
        answer8: "You can reach us via email or phone.",
        question9: "Do you have a mobile app?",
        answer9: "Yes, the app is available on both Android and iOS.",
        question10: "What products are available?",
        answer10: "We offer a wide range of products, including clothing, electronics, and perfumes.",
        question11: "Are there any additional shipping or tax fees?",
        answer11: "There may be shipping fees and taxes depending on the delivery location."
      },
      "termsAndConditions": {
    "label": "Terms and Conditions",
    "title": "Terms and Conditions",
    "intro": "Please read these Terms and Conditions carefully before using our platform and mobile application.",
    "sections": {
      "platform": {
        "title": "Our Platform Ashtari:",
        "content": "It is an electronic interface on a website and a mobile application that allows authorized suppliers to sell their products in the State of Kuwait by opening online stores to sell those products online to various customers inside and outside Kuwait."
      },
      "admin": {
        "title": "We, the Administrators:",
        "content": "All persons, administrators, and entities authorized by the company that owns the Ashtari platform and those representing it to manage and organize the operations of this website and application."
      },
      "customer": {
        "title": "You, the Customer:",
        "content": " Anyone using the platform, including store owners, customers of those stores, or visitors and browsers of the platform's web pages."
      },
      "account": {
        "title": "Personal Account on the Platform:",
        "content": "A set of data retained by the platform about the customer, allowing it to identify them uniquely. This data is classified as private, accessible only to the customer, or public, available to administrators and/or other customers or the general public, depending on its purpose."
      },
      "store": {
        "title": "Online Store:",
        "content": "A collection of pages on Ashtiri related to displaying products belonging to a legally authorized commercial entity licensed by the state to sell those products."
      },
      "agreement": {
        "title": "Acceptance of Terms:",
        "content": "Before accessing or using the platform, you acknowledge that you agree to comply with all the terms mentioned below. If you do not agree with any part of these terms, you may not continue to access the services provided by Ashtiri the website and the application."
      },
      "pricing": {
        "title": "Prices:",
        "content": "Prices are subject to change at any time, either increasing or decreasing, based on market conditions and changes in the prices of primary products that compel the manufacturer or supplier to change their product prices. We are an electronic platform that does not own the product; we are merely an intermediary between the seller and the buyer. The seller is solely responsible for pricing their products. We only sell the product on their behalf in exchange for a commission from each invoice deducted from the seller.\nBy using our website, you agree to our terms and conditions."

      },
      "purchases": {
        "title": "Purchases:",
        "content": "  You may be required to provide some personal information if you wish to purchase any product or service available through Ashtiri. All required information must be provided correctly and accurately to complete the purchase process. This information may include, but is not limited to, full name, address, phone number, and electronic payment card information (through an intermediary approved by the state central bank), among others. Providing false information may lead to the cancellation of the purchase and expose the customer to claims for financial compensation or legal action depending on the severity of the error in the information."
      },
      "suppliersAndCustomers": {
        "title": "Suppliers and Customers:",
        "content": "Important Note:\n- Ashtiri is not responsible for any dispute or conflict between the seller and the buyer.\n- Ashtiri is only an intermediary between the seller and the buyer.\n- If any unacceptable incident occurs from either party, Ashtiri is an unrelated third party in this dispute.\n- Ashtiri only displays the product for the seller and facilitates the purchase process for the customer."

      },
      "contentResponsibility": {
        "title": "Content:",
        "content": " Ashtiri allows customers to post, link, store, share, and make available certain information, graphics, videos, or other materials (Content). You are responsible for the content you post and bear the legal responsibility if it is found that this content constitutes a violation punishable by law, such as (but not limited to) spreading false news and defaming a person or store, publishing content aimed at blackmailing individuals, including explicit pornographic materials, impersonating others, using the site to upload malware or spread viruses or any harmful computer codes, using the platform to promote a competitor or publish unrelated content, representing an institution or entity without authorization, taking control of the platform wholly or partly and altering its design, infringing on other customers' rights, stealing personal accounts, or similar violations."
      },
      "ownership": {
        "title": "Intellectual Property Rights:",
        "content": "The electronic content on Ashtiri is its intellectual and legal property and must not be stolen, misused, or claimed by the customer unless it is public property or has been approved for reuse by the platform administrators."
      },
      "refunds": {
        "title": "Customer Entitlements from the Online Store:",
        "content": "The customer of the online store is entitled to request a refund of all or part of the sale transaction amount from the legal entity using the store during the return and exchange period and according to the store's terms and conditions published on the store's virtual site or at the time of purchase from the store within Ashtiri.\nWhen the legal entity using the store sets the terms and conditions governing the relationship between the store and its targeted customers, it sets the limits of responsibility between them.\nAshtiri is not obliged to compensate if one or more customers share their personal information with other customers.\nThe platform is not obliged to compensate the store if a customer returns products that do not comply with the store's return and exchange terms.\nThe online store or its representative is obligated to resolve disputes presented by the customer, ensure timely delivery of products, provide a product that matches the published details, refund the amount if there is an error in the provided product, and ensure the protection of customer data."
      },
      "changes": {
        "title": "Changes:",
        "content": "  Ashtiri reserves the right, at the discretion of its administrators, to modify or replace these terms at any time."
      },
      "contactUs": {
        "title": "Contact Us:",
        "content": "If you have any questions about these terms, please contact the platform administrators through the available communication methods."
      },
      "contac": {
        "content": "If we decide to change our policies and terms, we will post these changes on this page and/or update the date of modification of the terms and conditions policy below."
      },
      "lastUpdate": "Last modified on Monday, 12/08/2024."
    },
  
  },

"deliveryPolicy": {
    "label": "Delivery Policy",
    "content": {
      "title": "Delivery Terms",
      "description": "The following information outlines the delivery fees and estimated delivery timelines.",
      "cards": {
        "1": {
          "title": "1- Order Placement",
          "description": "Once the order is placed through Ashtiri, the customer will receive an email confirmation with an overview of the order. The email will include the order number, as well as all other details.",
          "missingInfo": "If any information is missing, the customer service team will contact the customer to complete the details."
        },
        "2": {
          "title": "2- Delivery Within Kuwait",
          "shippingCost": "Shipping cost: 2 KWD",
          "deliveryTime": "Delivery time:",
          "details": {
            "kuwait": "Kuwait: Within 2-3 business days.",
            "uae": "UAE: Within 8 business days.",
            "bahrain": "Bahrain: Within 8 business days.",
            "qatar": "Qatar: Within 8 business days.",
            "oman": "Oman: Within 8 business days."
          }
        },
        "3": {
          "title": "3- Delivery to Saudi Arabia",
          "cities": {
            "riyadh": "Riyadh: Within 2 to 5 business days.",
            "jeddah": "Jeddah, Dammam, Khobar: Within 4 to 6 business days.",
            "otherCities": "Other cities in Saudi Arabia: Within 5 to 7 business days."
          },
          "note": "To avoid any delays, please ensure that the full shipping address details are provided, along with a reachable contact number when placing the order."
        }
      }

    }
  },

      "returnPolicy": {
        "label": "Return Policy",
        "generalTerms": {
          "title": "General Return Terms:",
          "item1": "You can return products within 14 days of receipt.",
          "item2": "The product must be in its original condition with packaging and accessories.",
          "item3": "The original invoice or proof of purchase must be provided."
        },
        "nonReturnableItems": {
          "title": "Non-returnable Items:",
          "item1": "Used or opened products.",
          "item2": "Underwear.",
          "item3": "Damaged or modified products."
        },
        "returnProcess": {
          "title": "Return Process:",
          "description": "To submit a return request, please contact us via email or phone.",
          "step1": "The product will be inspected upon arrival to confirm the return.",
          "step2": "If the return is approved, the amount will be refunded within 10 business days."
        },
        "contactUs": {
          "title": "Contact Us:",
          "description": "If you have any inquiries or need further assistance, please contact us at:",
          "phone": "Phone number: 0096566111611",
          "email": "Email: support@ashtiri.com",
          "address": "Address:"
        }
      },
      "termsConditions": {
        "label": "Terms and Conditions"
      },
      "faqt": {
        "label": "FAQ"
      },
      "contact_us": "Contact Us",
      "support_text": "We are here to support you! Don't hesitate to reach out with any questions or suggestions.",
      "name": "Name",
      "email": "Email",
      "your_message": "Your Message",
      "send_message": "Send Message",
      "phone": "Phone",
      "address": "Address",
      "stores": "Stores", 

      "help_title": "Frequently Asked Questions",
      "help_intro": "Here you'll find answers to the most frequently asked questions. For more help, feel free to reach out.",
      "faq_questions": [
        { "question": "What payment methods are available?", "answer": "We accept KNet, Visa, MasterCard, and Cash on Delivery." },
        { "question": "How long does delivery take?", "answer": "Delivery time depends on the location, but it usually takes 3-7 working hours within Kuwait." },
        { "question": "Can I track my order?", "answer": "Yes, you will receive a tracking number once your order is shipped, and you can track it on our website." },
        { "question": "What is your return and exchange policy?", "answer": "We offer a flexible return policy within 14 days of receipt, provided the items are unused and in original condition." },
        { "question": "Do you offer international shipping?", "answer": "Yes, we provide shipping to most countries worldwide." },
        { "question": "Can I change or cancel my order after placing it?", "answer": "You can change or cancel your order within 2 hours of placing it; beyond that, it may have already been shipped." },
        { "question": "Do you have discounts or special offers?", "answer": "Yes, we offer discounts and special offers. Subscribe to our newsletter to stay updated on the latest deals." },
        { "question": "How can I contact customer support?", "answer": "You can reach us via email or phone. Contact details are available in the 'Contact Us' section." },
        { "question": "Do you have a mobile app?", "answer": "Yes, we have an app available on both Android and iOS for a more convenient shopping experience." },
        { "question": "What products do you offer?", "answer": "We offer a wide range of products including clothing, electronics, skincare, perfumes, and many other categories." },
        { "question": "Are there additional shipping or tax fees?", "answer": "There may be shipping and tax fees based on the delivery location, which will be clarified at checkout." }
      ],
      "contact_support": "Didn't find your answer here? You can <a href='/contact'>contact us</a> for further assistance.",
    

 
      "Close": "Close",
      "Address Book": "Address Book",
      "Default": "Default",
      "Check": "Check",
      "Edit": "Edit",
      "Next": "Next",
      "Available Payment Methods": "Available Payment Methods",
      "Done": "Done",
      "Edit Payment Method": "Edit Payment addre",
      "Add New Payment Method": "Add New Payment address",
      "Full Name": "Full Name",
      "Phone Number": "Phone Number",
      "Preferred Delivery Time (optional)": "Preferred Delivery Time (optional)",
      "Address: City / State / Street": "Address: City / State / Street",
      "Postal Code (optional)": "Postal Code (optional)",
      "Set as Default": "Set as Default",
      "Delete": "Delete",
      "Cancel": "Cancel",
      "Save": "Save",
      "Current password": "Current password",
      "New password": "New password",
      "Password confirmation": "Password confirmation",
      "Returns orders": "Returns orders",
      "Request Returns": "Request Returns",
      "Cancel Returns": "Cancel Returns",
      "customer_reviews": "Customer reviews",
      "customer_ratings": "Customer ratings",
      "cash_on_delivery": "Cash on delivery",
      "delete_address": "Delete",
      "addCoupon": "Add Coupon",
      "enterCoupon": "Enter your coupon code",
      "add_new_address_prompt": "Please add a new address to proceed",
      "relatedProducts": "Related Products",
      "clearSortAndFilter": "Clear Sorting and Filtering",
      "influencers": "Influencers",
      "help": "Help",
      "rateThis": "Rate this!",
      "close": "Close"
    
      


    

    }

  },
  ar: {
    translation: {
      "Welcome": "مرحبًا بكم في الموقع",
      "About Us": "معلومات عنا",
      "Careers": "وظائف",
      "Contact US": "اتصل بنا",
      "Stores": "المتاجر",
      "follow Us On": "اتبعنا",
      "Category": "فئة",
      "Offers": "عروض",
      "New arrival": "جديد",
      "SHOW MORE": "عرض المزيد",
      "HIDE":"إخفاء",
      "YOUR ONE-STEP SHOP TO": "متجرك الشامل لجميع احتياجاتك",
      "ALL WHAT YOU NEED": "كل ما تحتاجه",
      "EMPLOYERS": "أصحاب العمل",
      "PRODUCTS": "المنتجات",
      "LANGUAGES": "اللغات",
      "WAREHOUSES": "المستودعات",
      "brands": "العلامات التجارية",
      "categories": "الفئات",
      "prices": "الأسعار",
      "discounts": "الخصومات",
      "colors": "الألوان",
      "sizes": "المقاسات",
      "Products": "المنتجات",
      "Sort by": "ترتيب حسب",
      "Store categories": "فئات المتجر",
      "+Follow": "+ متابعة",
      "products search...": "البحث عن المنتجات...",
      
      "Track Orders": "تتبع الطلبات",
      "Order Number": "رقم الطلب",
      "Order": "الطلب",
      "Date": "التاريخ",
      "Status": "الحالة",
      "Total": "المجموع",
      "For": "لـ",
      "Items": "عنصر",
      "Actions": "الإجراءات",
      "View": "عرض",
      "Total Quantity": "الكمية الإجمالية",
      "Total Price": "إجمالي السعر",
      "Promos & Vouchers": "العروض والقسائم",
      "Discount Voucher": "قسيمة الخصم",
      "Shipping Fee": "رسوم الشحن",
      "Order Received": "تم استلام الطلب",
      "In Progress": "قيد التنفيذ",
      "On The Way": "في الطريق",
      "Delivered": "تم التوصيل",
      "Your request has been received successfully.": "تم استلام طلبك بنجاح.",
      "Your request is in progress.": "طلبك قيد المعالجة.",
      "The order has been shipped. It should arrive within 24 hours.": "تم شحن الطلب، سيصل خلال 24 ساعة.",
      "Your order has been successfully delivered.": "تم توصيل طلبك بنجاح.",

      "Cancel Returns & Exchanges": "إلغاء الإرجاع والتبديل",
      "On the way to get the order": "في الطريق لاستلام الطلب",
      "Received & inspected": "تم الاستلام والتفتيش",
      "Your return request has been received.": "تم استلام طلب الإرجاع الخاص بك.",
      "The representative is on his way to receive the product.": "المندوب في الطريق لاستلام المنتج.",
      "Returns": "إرجاع",
      "Exchanges": "تبديل",
      "Returns & Exchanges": "الإرجاع والتبديل",
      "Request Returns & Exchanges": "طلب إرجاع وتبديل",
      "You Have No Returns History": "ليس لديك سجلات إرجاع",
      "You Have No Exchanges History": "ليس لديك سجلات تبديل",
      "Filter": "تصفية",

      "Personal Information": "المعلومات الشخصية",
      "First Name": "الاسم الأول",
      "Last Name": "اسم العائلة",
      "Date Of Birth": "تاريخ الميلاد",
      "Gender": "الجنس",
      "Female": "أنثى",
      "Male": "ذكر",
      "Choose Language": "اختر اللغة",
      "Ar": "العربية",
      "En": "الإنجليزية",
      "Number": "رقم الهاتف",
      "Nationality": "الجنسية",
      "Address": "العنوان",
      "Image": "الصورة",
      "Click Here to upload Photo": "اضغط هنا لرفع الصورة",
      "Submit": "إرسال",
      "Security": "الأمان",
      "Email": "البريد الإلكتروني",
      "Password": "كلمة المرور",
      "Change Password": "تغيير كلمة المرور",
      "Log Out": "تسجيل الخروج",
      "Delete Account": "حذف الحساب",
      "Payment Methods": "طرق الدفع",
      "Add New Card": "إضافة بطاقة جديدة",
      "Your Payment Method is empty": "طرق الدفع الخاصة بك فارغة",

      "My Points": "نقاطي",
      "YOUR POINTS": "نقاطك",
      "Earned this month": "تم الحصول عليها هذا الشهر",
      "Ends this month": "تنتهي هذا الشهر",
      "points": "نقاط",
      "Available balance": "الرصيد المتاح",
      "Buy more and earn points": "اشترِ المزيد واكسب نقاط",
      "One point is equal to one dinar": "النقطة الواحدة تساوي دينارًا واحدًا",
      "Points expire after one year": "النقاط تنتهي صلاحيتها بعد سنة واحدة",
      "My Orders": "طلباتي",

      "Wishlist": "قائمة الرغبات",
      "Off": "خصم",
      "Your Wishlist is empty": "قائمة الرغبات فارغة",
      'Points': 'نقاط',
      "myAccount": "حسابي",
      "myOrders": "طلباتي",
      "trackOrders": "تتبع الطلبات",
      "returns": "إرجاع",
      "wishlistInfluencer": "قائمة الأمنيات والمؤثرين",
      "myPoints": "نقاطي",
      "Welcome to the new Experience": "مرحبًا بكم في التجربة الجديدة",
      "Create your password": "أنشئ كلمة المرور الخاصة بك",
      "Confirm Password": "تأكيد كلمة المرور",
      "CONTINUE": "استمرار",
      "Password changed successfully": "تم تغيير كلمة المرور بنجاح",
      "Please log in now.": "يرجى تسجيل الدخول الآن.",
      "VERIFY YOUR EMAIL ADDRESS": "تأكيد عنوان بريدك الإلكتروني",
      "Verify your email using the OTP sent to your email address": "قم بتأكيد بريدك الإلكتروني باستخدام رمز التحقق المرسل إلى عنوان بريدك الإلكتروني",
      "Resend OTP": "إعادة إرسال رمز التحقق",
      "OTP": "رمز التحقق",
      "Please enter email": "يرجى إدخال البريد الإلكتروني",
      "Create your account": "أنشئ حسابك",
      "Log in": "تسجيل الدخول",
      "Sign up": "إنشاء حساب",
      "Forgot Password": "نسيت كلمة المرور",
      "OR LOGIN WITH SOCIAL": "أو تسجيل الدخول عبر وسائل التواصل",
      "Login Instagram": "تسجيل الدخول عبر إنستجرام",
      "Login Apple": "تسجيل الدخول عبر Apple",
      "welcome": "مرحبًا بك في التجربة الجديدة",
      "createAccount": "أنشئ حسابك",
      "login": "تسجيل الدخول",
      "signup": "إنشاء حساب",
      "enterEmail": "يرجى إدخال البريد الإلكتروني",
      "password": "كلمة المرور",
      "firstName": "الاسم الأول",
      "lastName": "الاسم الأخير",
      "eightCharsMin": "8 أحرف على الأقل",
      "oneLetter": "على الأقل حرف واحد",
      "oneNumber": "على الأقل رقم واحد",
      "orLoginWithSocial": "أو تسجيل الدخول عبر الشبكات الاجتماعية",
      "loginInstagram": "تسجيل الدخول عبر إنستجرام",
      "loginApple": "تسجيل الدخول عبر آبل",
      "continue": "استمرار",
       "loginWithGoogle": "تسجيل الدخول باستخدام Google",
      "loginWithFacebook": "تسجيل الدخول باستخدام Facebook",
      "fillFieldsWithValidInfo": "يرجى ملء جميع الحقول بمعلومات صحيحة.",
      "passwordRequirements": "يجب أن تحتوي كلمة المرور على أحرف كبيرة وصغيرة وأرقام.",
      "registrationFailed": "فشل التسجيل. حاول مرة أخرى.",
      "generalError": "حدث خطأ. حاول مرة أخرى لاحقاً.",
      "loginSuccessful": "تم تسجيل الدخول بنجاح!",
      "favorites": "المفضلة",
      "new_arrival": "الواصلون الجدد",
      "E-mail": "البريد الإلكتروني",
      "Sign Up": "إنشاء حساب",
      "SELL ON ASHTIRI": "بيع على أشتري",
      "Recommend for You": "مقترح لك",
      "Best of": "الأفضل",
      "Whats hot in category": "الأكثر رواجًا في الفئة",
      "Store": "المتاجر",
      "Influencer": "المروجون",
      "product_details": "تفاصيل المنتج",
      "material": "المادة",
      "material_composition": "تركيب المادة",
      "care_instructions": "تعليمات العناية",
      "comfort": "راحة الطبيعة",
      "occasion": "المناسبة",
      "model": "الطراز",
      "shipping": "الشحن",
      "reviews": "المراجعات",
      "average_rating": "التقييم العام",
      "out_of": "من",
      "stars": "نجوم",
      "add_to_basket": "أضف إلى السلة",
      "buy_now": "اشترِ الآن",
      "write_review": "اكتب مراجعة",
      "what_do_you_think": "ما رأيك في هذا المنتج؟",
      "no_comments_yet": "لا توجد تعليقات بعد.",
      "write_comment": "اكتب تعليقك هنا...",
      "addToBasket": "أضف إلى السلة",
      "buyNow": "اشتري الآن",
      "color": "اللون",
      "size": "الحجم",
      "quantity": "الكمية",
      "productDetails": "تفاصيل المنتج",
      "materialComposition": "تركيبة الخامة",
      "warrantyAndCare": "الضمان والرعاية",
      "careInstructions": "تعليمات العناية",
      "generalSpecifications": "المواصفات العامة",
      "naturesComfort": "راحة الطبيعة",
      "averageRating": "متوسط التقييم",
      "outOf": "من أصل 5 نجوم",
      "writeReview": "أضف مراجعة",
      "commentPlaceholder": "اكتب تعليقك هنا...",
      "productComments": "تعليقات المنتج",
      "noComments": "لا توجد تعليقات بعد.",
      "submit": "إرسال",
      "selectColor": "من فضلك اختر لون",
      "selectSize": "من فضلك اختر مقاس",
      "selectQuantity": "من فضلك اختر الكمية",
      "trending": "شائع",
      "total_quantity": "الكمية الإجمالية",
      "total_price": "السعر الكلي",
      "discount_voucher": "قسيمة الخصم",
      "shipping_fee": "رسوم الشحن",
      "checkout_now": "الدفع الآن",
      "payment_methods": "طرق الدفع المتاحة:",
      "new_customers": "للعملاء الجدد",
      "off": "خصم",
      "please_enter_order_code": "من فضلك ادخل كود الطلب",

      
      "Ashtiri Intro": "أشترِي هو سوق متعدد المتاجر عبر الإنترنت في الكويت والخليج، يقدم حلولًا مريحة وموثوقة لتلبية جميع احتياجاتك اليومية، سواء كنت امرأة، طفل، أو رجل. 🛍️🌟",
      "Founded in 2024": "تأسست في عام 2024، تهدف أشترِي إلى ربط الموردين والمستهلكين، وتقديم منتجات عالية الجودة من أشهر العلامات التجارية الفاخرة في مجال الأزياء والجمال.",
      "Our Mission": "مهمتنا",
      "Our Goal": "نهدف إلى أن نكون الشركة الأكثر اهتمامًا بالعملاء في الشرق الأوسط، من خلال توفير تجربة تسوق استثنائية ومريحة. 🎯",
      "Our Values": "قيمنا",
      "Customer First": "العميل أولاً",
      "Passion for Excellence": "شغف التميز",
      "Operational Excellence": "التميز التشغيلي",
      "Long Term Thinking": "التفكير على المدى الطويل",
      "Customer Feedback": "الاستماع إلى آراء العملاء",
      "Our Products": "منتجاتنا",
      "Products Range": "اختر من بين مجموعة واسعة من المنتجات، بما في ذلك الملابس، الرياضة، الأحذية، الحقائب، العطور، المكياج، النظارات الشمسية، الساعات، وأكثر من ذلك بكثير. 🛒",
      "Contact Us": "اتصل بنا",
      "Contact Help Text": "لا يمكنك العثور على الإجابة التي تبحث عنها؟ نحن هنا للمساعدة:",
      "Phone": "الهاتف",
      "Mobile & WhatsApp": "الموبايل وواتساب",
        faq: {
          question1: "ما هي طرق الدفع المتاحة؟",
          answer1: "نقبل كي نت، فيزا، ماستر كارد، والدفع عند الاستلام.",
          question2: "كم من الوقت يستغرق توصيل الطلبات؟",
          answer2: "يعتمد على الموقع، وعادةً ما يستغرق بين 3 إلى 7 ساعات عمل داخل الكويت.",
          question3: "هل يمكنني تتبع طلبي؟",
          answer3: "نعم، ستتلقى رقم تتبع ويمكنك متابعة حالة الطلب عبر موقعنا.",
          question4: "ما هي سياسات الإرجاع والاستبدال؟",
          answer4: "نقدم سياسة إرجاع مرنة خلال 14 يوما من استلام الطلب.",
          question5: "هل تقدمون شحنا دوليا؟",
          answer5: "نعم، نوفر خدمة الشحن إلى معظم الدول.",
          question6: "هل يمكنني تغيير أو إلغاء طلبي بعد تقديمه؟",
          answer6: "يمكن تغيير أو إلغاء الطلب في غضون ساعتين من تقديمه.",
          question7: "هل لديكم خصومات أو عروض خاصة؟",
          answer7: "نعم، نقدم بانتظام خصومات وعروضا خاصة.",
          question8: "كيف يمكنني الاتصال بخدمة العملاء؟",
          answer8: "يمكنك التواصل معنا عبر البريد الإلكتروني أو الهاتف.",
          question9: "هل لديكم تطبيق للهواتف الذكية؟",
          answer9: "نعم، التطبيق متاح على نظامي أندرويد وآيفون.",
          question10: "ما هي المنتجات المتوفرة لديكم؟",
          answer10: "نوفر مجموعة واسعة من المنتجات تشمل الملابس والإلكترونيات والعطور.",
          question11: "هل توجد رسوم إضافية على الشحن أو الضرائب؟",
          answer11: "قد توجد رسوم شحن وضرائب حسب موقع التسليم."
        }, 
        "termsAndConditions": {
          "label": "الشروط والأحكام",
          "title": "الشروط والأحكام",
          "intro": "يرجى قراءة هذه الشروط والأحكام بعناية قبل استخدام منصتنا وتطبيقها على الهاتف المحمول.",
          "sections": {
            "platform": {
              "title": "منصتنا أشتري:",
              "content": "هي واجهة الكترونية تحت موقع انترنت وتطبيق للهاتف المحمول تتيح للموردين المخولين ببيع منتجاتهم في بدولة الكويت بفتح متاجر الكترونية بغرض بيع تلك المنتجات عبر الانترنت الى عملاء مختلفين داخل وخارج دولة الكويت."
            },
            "admin": {
              "title": "نحن المشرفون:",
              "content": "جميع الأشخاص والمشرفين والجهات المخولة من قبل الشركة المالكة لمنصة أشتري ومن يمثلها للتحكم وتنظيم العمليات على هذا الموقع والتطبيق."
            },
            "customer": {
              "title": "أنت العميل:",
              "content": "أي شخص يستخدم المنصة سواءً كان من أصحاب المتاجر أو زبائن تلك المتاجر، أو زائراً يتصفح صفحات الإنترنت الخاصة بمنصة أشتري."
            },
            "account": {
              "title": "الحساب الشخصي على المنصة:",
              "content": "هو مجموع البيانات التي تحتفظ فيها المنصة عن العميل والتي تسمح لها بالتعرف عليه دون غيره من العملاء وتقسم هذه البيانات (بتقدير المشرفين على المنصة) الى خاصة لا يطلع عليها الا العميل نفسه أو عامة متاحة حسب الغرض منها للمشرفين و/أو لعملاء آخرين أو للعلن بشكل عام."
            },
            "store": {
              "title": "المتجر الإلكتروني:",
              "content": "هو مجموعة الصفحات على منصة أشتري المتعلقة بعرض منتجات تعود إلى جهة اعتبارية تجارية رسمية مرخصة من قبل الدولة لبيع هذه المنتجات."
            },
            "agreement": {
              "title": "الموافقة على الشروط:",
              "content": "قبل الوصول إلى أو استخدام المنصة تقر أنك توافق على الالتزام بجميع الشروط المذكورة ادناه. إذا كنت لا توافق على أي جزء من هذه الشروط، لا يمكنك الاستمرار بالوصول إلى الخدمات المقدمة من خلال منصة وتطبيق اشتري."
            },
            "pricing": {
              "title": "الأسعار:",
              "content": "الأسعار قابلة للتغيير بأي لحظة، سواء بالزيادة أو النقصان وذلك حسب ظروف السوق ومتغيرات أسعار المنتجات الأولية التي تجبر المصنع أو المورد إلى تغيير أسعار منتجاته. مع العلم أننا منصة إلكترونية لا نملك المنتج، نحن فقط وسيط بين البائع والمشتري، والبائع هو المسؤول أولاً وأخيراً عن تسعير منتجاته. نحن فقط نبيع المنتج له بمقابل نسبة من كل فاتورة تخصم من البائع. موافقتك: باستخدام موقعنا، فإنك توافق على الشروط والأحكام الخاصة بنا."

              
            },
            "purchases": {
              "title": "المشتريات:",
              "content": "قد تتم مطالبتك بتوفير بعض المعلومات ذات الصلة الخاصة بك إذا كنت ترغب في شراء أية منتج أو خدمة متاحة من خلال منصة أشتري، يجب تقديم جميع المعلومات المطلوبة بصورة صحيحة ودقيقة لإتمام عملية الشراء. هذه المعلومات، على سبيل المثال لا الحصر، الاسم الثلاثي، العنوان، رقم الهاتف، ومعلومات بطاقة الدفع الالكتروني (عن طريق وسيط معتمد من قبل البنك المركزي للدولة)، وغيرها. التعمد بتقديم معلومات خاطئة قد يعرض عملية الشراء الى الإلغاء ويعرض العميل للمطالبة بالتعويض المادي أو الملاحقة القانونية حسب تقدير جسامة الخطأ في تلك المعلومات."
            },
            "suppliersAndCustomers": {
              "title": "الموردون والعملاء:",
              "content": "ملاحظة هامة:\n- اشتري غير مسؤول عن اي خلاف او نزاع يحصل بين البائع والمشتري.\n- اشتري فقط وسيط بين البائع والمشتري.\n- اذا حدث اي امر غير مقبول من احد الاطراف البائع او المشتري فان اشتري هو طرف اخر ليس له علاقة بهذا النزاع.\n- اشتري فقط يعرض المنتج للبائع و يسهل عملية الشراء على العميل."
            },
            "contentResponsibility": {
              "title": "المحتوى:",
              "content": "منصة أشتري تتيح للعملاء بنشر وربط وتخزين ومشاركة محتوى وإتاحة بعض المعلومات والرسومات، وأشرطة الفيديو أو المواد الأخرى (المحتوى). أنت مسؤول عن المحتوى المنشور من قبلكم وتتحمل وحدك المسؤولية القانونية اذا ثبت ان هذا المحتوى يمثل مخالفة يعاقب عليها القانون مثل (على سبيل المثال وليس الحصر) نشر الأخبار والأكاذيب التي تتعلق بتشوية الصورة العامة لأحد الأشخاص أو المتاجر، أو نشر محتوى يستهدف ابتزاز أحد الأفراد أو يضم مواد إباحية فاضحة، أو انتحال المستخدم لهوية أحد الأفراد، أو استخدام الموقع لتحميل برامج ضارة أو نشر فيروسات أو أي شيفرات حاسوبية مؤذية، أو استخدام المنصة في الترويج لمنافس أو نشر محتوى لا علاقة له بالخدمات المقدمة، أو تمثيل أحد المؤسسات أو الهيئات بدون أن يكون العميل مخولًا بادعاء هذا التمثيل، أو السيطرة على المنصة كلها أو جزءا منها والتغير من تصميمها أو التعديل فيه، أو التعدي على حقوق العملاء الأخريين وسرقة حساباتهم الشخصية أو ما يشابهها من انتهاكات."
            },
            "ownership": {
              "title": "حقوق الملكية الفكرية:",
              "content": "المحتوى الالكتروني في منصة أشتري هو ملك فكريا وقانونيا لاشتري فلا يجوز للعميل سرقته أو سوء استغلاله، أو التعمد إلى نسبه إليه إلا ما هو أصلا ملكية عامة أو ما تم الحصول على الموافقة على اعادة استخدامه من قبل المشرفين على المنصة."
            },
            "refunds": {
              "title": "استحقاقات العملاء من المتجر الإلكتروني:",
              "content": "يحق لعميل المتجر الالكتروني المطالبة بإسترجاع كلا أو جزءا من مبلغ صفقة البيع من الجهه القانونية المستخدمة للمتجر خلال فترة الاسترجاع والتبديل وحسب الشروط المعلن لذلك المتجر في صفحة الشروط والاحكام في موقع المتجر الافتراضي و/أو عند الشراء من ذلك المتجر داخل منصة أشتري.\nعندما يضع الجهة القانونية المستخدمة للمتجر الشروط والأحكام المنظمة بين ذلك المتجر وبين عملائه المستهدفين، فهي بذلك تضع حدود للمسؤولية بينها وبينهم. منصة و تطبيق أشتري غير ملزمه بالتعويض إذا قام أحد أو أكثر من العملاء بمشاركة معلوماتهم الشخصية مع أحد العملاء الأخريين. المنصة غير ملزمه بتعويض المتجر إذا قام أحد العملاء بإرجاع منتجات لا توافق بنود الاسترجاع والاستبدال في تلك المتاجر. المتجر الالكتروني أو من يمثله ملزم بتسوية المنازعات التي يتقدم لها العميل، وملزم بعملية توصيل المنتجات في أوقاتها، وملزم أيضاً أن يقدم للعميل منتجاً يوافق التفاصيل التي تم نشرها، وملزم كذلك على رد المبلغ لصاحبه إذا ما وجد خطأ في المنتج المقدم، وملزم كذلك على توفير حماية لبيانات العملاء."

            },
            "changes": {
              "title": "التغييرات:",
              "content": "منصة أشتري تحتفظ بالحق، حسب تقدير المشرفين عليها، لتعديل أو استبدال هذه الشروط في أي وقت."
            },
            "contactUs": {
              "title": "اتصل بنا:",
              "content": "إذا كان لديك أية أسئلة حول هذه الشروط، يرجى الاتصال بالمشرفين على المنصة عن وسائل التواصل المتاحة لذلك."
            },
            "contac": {
              "content": "إذا قررنا تغيير سياساتنا و الشروط الخاصة بنا، فسنقوم بنشر هذه التغييرات على هذه الصفحة و / أو تحديث تاريخ تعديل سياسة الشروط و الاحكام أدناه"
            },
            "lastUpdate": "تم إجراء آخر تعديل على هذه السياسة يوم الأربعاء، بتاريخ 03/07/2024."
          }
        },
        "deliveryPolicy": {
    "label": "سياسة التوصيل",
    "content": {
      "title": "شروط التوصيل",
      "description": "توضح المعلومات التالية تفاصيل رسوم التوصيل والجداول الزمنية المقدرة للتوصيل",
      "cards": {
        "1": {
          "title": "1- تقديم الطلب",
          "description": "بمجرد تقديم الطلب من خلال أشتري، سوف يتلقى العميل رسالة تأكيد بالبريد الإلكتروني تتضمن لمحة عامة عن الطلب. سيحتوي البريد الإلكتروني على رقم الطلب، بالإضافة إلى جميع التفاصيل الأخرى.",
          "missingInfo": "في حالة وجود معلومات ناقصة، سيتصل فريق خدمة العملاء بالعميل لاستكمال البيانات."
        },
        "2": {
          "title": "2- التوصيل داخل دولة الكويت",
          "shippingCost": "تكلفة الشحن: 2 دينار كويتي",
          "deliveryTime": "وقت التوصيل:",
          "details": {
            "kuwait": "الكويت: خلال 2-3 أيام عمل.",
            "uae": "الإمارات العربية المتحدة: خلال 8 أيام عمل.",
            "bahrain": "البحرين: خلال 8 أيام عمل.",
            "qatar": "قطر: خلال 8 أيام عمل.",
            "oman": "عُمان: خلال 8 أيام عمل."
          }
        },
        "3": {
          "title": "3- التوصيل إلى المملكة العربية السعودية",
          "cities": {
            "riyadh": "الرياض: خلال 2 إلى 5 أيام عمل.",
            "jeddah": "جدة، الدمام، الخبر: خلال 4 إلى 6 أيام عمل.",
            "otherCities": "مدن المملكة الأخرى: خلال 5 إلى 7 أيام عمل."
          },
          "note": "لتجنب أي تأخير، يُرجى التأكد من ملء تفاصيل عنوان الشحن بالكامل، بالإضافة إلى إضافة رقم اتصال متاح عند تقديم الطلب."
        }
      }
    }
  },
    
  "returnPolicy": {
    "label": "سياسة الإرجاع",
    "generalTerms": {
      "title": "الشروط العامة للاسترجاع:",
      "item1": "يمكنك إرجاع المنتجات خلال 14 يومًا من الاستلام.",
      "item2": "يجب أن يكون المنتج في حالته الأصلية مع التغليف والإكسسوارات.",
      "item3": "يجب تقديم الفاتورة الأصلية أو إثبات الشراء."
    },
    "nonReturnableItems": {
      "title": "المنتجات غير القابلة للاسترجاع:",
      "item1": "المنتجات المستخدمة أو المفتوحة.",
      "item2": "الملابس الداخلية.",
      "item3": "المنتجات التالفة أو المعدلة."
    },
    "returnProcess": {
      "title": "عملية الاسترجاع:",
      "description": "لتقديم طلب استرجاع، يرجى التواصل معنا عبر البريد الإلكتروني أو الهاتف.",
      "step1": "سيتم فحص المنتج عند وصوله لتأكيد الاسترجاع.",
      "step2": "إذا تم الموافقة على الاسترجاع، سيتم استرداد المبلغ في غضون 10 أيام عمل."
    },
    "contactUs": {
      "title": "اتصل بنا:",
      "description": "إذا كان لديك أي استفسارات أو تحتاج إلى مزيد من المساعدة، يرجى التواصل معنا عبر:",
      "phone": "رقم الهاتف: 0096566111611",
      "email": "البريد الإلكتروني: support@ashtiri.com",
      "address": "العنوان:"
    }
  },

  "termsConditions": {
    "label": "الشروط والأحكام"
  },
  "faqt": {
    "label": "الأسئلة الشائعة"
  },
 
  "contact_us": "تواصل معنا",
  "support_text": "نحن هنا لدعمك! لا تتردد في التواصل معنا لأي استفسارات أو اقتراحات.",
  "name": "الاسم",
  "email": "البريد الإلكتروني",
  "your_message": "رسالتك",
  "send_message": "إرسال الرسالة",
  "phone": "الهاتف",
  "address": "العنوان",
  "stores": "المتاجر", 

    
    
  "help_title": "الأسئلة الشائعة",
  "help_intro": "هنا تجد الإجابات عن الأسئلة الأكثر شيوعًا. لمزيد من المساعدة، لا تتردد في التواصل معنا.",
  "faq_questions": [
    { "question": "ما هي طرق الدفع المتاحة؟", "answer": "نقبل كي نت، فيزا، ماستر كارد، والدفع عند الاستلام." },
    { "question": "كم من الوقت يستغرق توصيل الطلبات؟", "answer": "يعتمد وقت التوصيل على الموقع، ولكن عادةً ما يستغرق بين 3 إلى 7 ساعات عمل داخل الكويت." },
    { "question": "هل يمكنني تتبع طلبي؟", "answer": "نعم، ستتلقى رقم تتبع بمجرد شحن طلبك ويمكنك متابعة حالة الطلب عبر موقعنا." },
    { "question": "ما هي سياسات الإرجاع والاستبدال؟", "answer": "نقدم سياسة إرجاع مرنة خلال 14 يومًا من الاستلام بشرط أن تكون المنتجات غير مستخدمة وفي حالتها الأصلية." },
    { "question": "هل تقدمون شحناً دولياً؟", "answer": "نعم، نوفر خدمة الشحن إلى معظم الدول حول العالم." },
    { "question": "هل يمكنني تغيير أو إلغاء طلبي بعد تقديمه؟", "answer": "يمكن تغيير أو إلغاء الطلب خلال ساعتين من تقديمه، بعد ذلك قد يكون قد تم شحنه." },
    { "question": "هل لديكم خصومات أو عروض خاصة؟", "answer": "نعم، نقدم خصومات وعروضاً خاصة. اشترك في نشرتنا الإخبارية لمتابعة أحدث العروض." },
    { "question": "كيف يمكنني الاتصال بخدمة العملاء؟", "answer": "يمكنك التواصل معنا عبر البريد الإلكتروني أو الهاتف. تفاصيل الاتصال في قسم 'اتصل بنا'." },
    { "question": "هل لديكم تطبيق للهواتف الذكية؟", "answer": "نعم، لدينا تطبيق متاح على نظامي أندرويد و iOS للاستمتاع بتجربة تسوق أسهل." },
    { "question": "ما هي المنتجات المتوفرة لديكم؟", "answer": "نوفر مجموعة واسعة من المنتجات تشمل الملابس، الإلكترونيات، العناية بالبشرة، العطور، والعديد من الفئات الأخرى." },
    { "question": "هل توجد رسوم إضافية على الشحن أو الضرائب؟", "answer": "قد تكون هناك رسوم شحن وضرائب بناءً على موقع التسليم وسيتم توضيحها عند إتمام عملية الشراء." }
  ],
  "contact_support": "لم تجد إجابتك هنا؟ يمكنك <a href='/contact'>التواصل معنا</a> لمزيد من المساعدة.",


  "Close": "إغلاق",
  "Address Book": "دفتر العناوين",
  "Default": "افتراضي",
  "Check": "تحديد",
  "Edit": "تعديل",
  "Next": "التالي",
  "Available Payment Methods": "طرق الدفع المتاحة",
  "Done": "تم",
  "Edit Payment Method": "تعديل عنوان الدفع",
  "Add New Payment ": "أضف عنوان الدفع الجديد",
  "Full Name": "الاسم الكامل",
  "Phone Number": "رقم الهاتف",
  "Preferred Delivery Time (optional)": "وقت التسليم المفضل (اختياري)",
  "Address: City / State / Street": "العنوان: المدينة / الولاية / الشارع",
  "Postal Code (optional)": "الرمز البريدي (اختياري)",
  "Set as Default": "تعيين كافتراضي",
  "Delete": "حذف",
  "Cancel": "إلغاء",
  "Save": "حفظ",
  "Current password": "كلمة المرور الحالية",
  "New password": "كلمة المرور الجديدة",
  "Password confirmation": "تأكيد كلمة المرور",
  "Returns orders": "إرجاع الطلبات",
  "Request Returns": "طلب إرجاع",
  "Cancel Returns": "إلغاء الإرجاع",
  "customer_reviews": "آراء العملاء",
  "customer_ratings": "تقييمات العملاء",
  "cash_on_delivery": "الدفع عند الاستلام",
  "delete_address": "حذف",
  "addCoupon": "أضف كوبون",
  "enterCoupon": "أدخل رمز الكوبون الخاص بك",
  "add_new_address_prompt": "من فضلك قم بإضافة عنوان جديد للمتابعة",
  "relatedProducts": "منتجات متعلقة",
  "clearSortAndFilter": "إلغاء الترتيب والتصفية",
  "influencers": "المؤثرون",
  "help": "المساعدة",
  "rateThis": "قيّم هذا!",
  "close": "إغلاق"






    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: "ar", // اللغة الافتراضية
  interpolation: {
    escapeValue: false
  }
});

export default i18n;